export class HideElement {
    #refs;
    constructor(element) {
        this.#refs = {
            el: element
        }

        this.init();
    }

    /**
     * Element = all elements within document
     * children = Only target elements within this element
     */
    get settings() {
        return {
            elements: this.#refs.el.getAttribute('data-hide-element'),
            children: this.#refs.el.getAttribute('data-hide-children')
        };
    }

    #addHiddenClass() {
        let allElements;
        if(this.settings.elements) {
            allElements = [...document.querySelectorAll(this.settings.elements)];
        };
        if(this.settings.children) {
            allElements = [...this.#refs.el.querySelectorAll(this.settings.elements)];
        };
        if(!allElements) return;
        for(let el of allElements) {
            el.classList.add('is-hidden');
        };
    }

    init() {
        this.#addHiddenClass();
    }
}